import enLocale from 'element-ui/lib/locale/lang/en'
import common from './common'
import meta from './meta'
import error from './error'
import companyJobList from './companyJobList'
import jobFilter from './jobFilter'
import navBar from './navBar'
import admin from './admin'
import onboarding from './onboarding'
import microSite from './microSite'
import jobDetail from './jobDetail'
import survey from './survey'
import login from './login'
import personal from './personal'
import questionnaire from './questionnaire'
import hm from './hm'
import thirdParty from './thirdParty'
import company from './company'

export default {
  ...enLocale,
  common,
  meta,
  error,
  companyJobList,
  jobFilter,
  navBar,
  admin,
  onboarding,
  microSite,
  jobDetail,
  survey,
  login,
  personal,
  questionnaire,
  hm,
  thirdParty,
  company
}
